// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"28b88f14","701":"114ce93b"}[chunkId] + ".chunk.css";
};